import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Mail from "../components/Mail";
import { initialize } from "../store/pagedata";
import { useDispatch } from "react-redux";

const Apply = () => {
  const dispatch = useDispatch();
  const destination = "apply@edhrec.com";

  useEffect(() => {
    dispatch(initialize());
  }, []);

  return (
    <Layout>
      <Helmet>
        <meta name="description" content="Apply to write for EDHREC" />
        <meta name="keywords" content="EDHREC,apply,write,author,article,wordpress" />
        <title>Apply | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ "/apply": "Apply" }]} />
      <h4 className="page-heading">Write for EDHREC</h4>
      <Mail
        description={
          <>
            <p>
              EDHREC is always on the lookout for new perspectives to add to our talented roster of
              contributors. We do not publish ad hoc articles or deck techs at this time but we are
              interested in prospective authors who have an idea for a series of articles with a
              central theme.
            </p>
            <p>
              If you have an idea for a novel and innovative series, complete this form or email
              your pitch to{" "}
              <a href={`mailto:${destination}`} rel="noreferrer" target="_blank">
                {destination}
              </a>
              . Good pitches will contextualize or incorporate EDHREC data. Excellent pitches will
              also be free from spelling and grammar mistakes.
            </p>
          </>
        }
        destination={destination}
      />
    </Layout>
  );
};

export default Apply;
